
import './imageLoader.css';
import { IMAGE_DECHARGE_URL } from '../../config/runtimeConfig';

export default function ImageLoader({ imageLabel, fileDecharge, setFileDecharge, imgUrl, subPath, imgWidth, imgHeight, downloadIcon = false }) {
    const downloadCarteImage = async () => {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", `${IMAGE_DECHARGE_URL}/${subPath}/${imgUrl}`, true);
        xhr.responseType = "blob";
        xhr.onload = function(){
            var urlCreator = window.URL || window.webkitURL;
            var imageUrl = urlCreator.createObjectURL(this.response);
            var tag = document.createElement('a');
            tag.href = imageUrl;
            tag.download = imgUrl.slice(13);
            document.body.appendChild(tag);
            tag.click();
            document.body.removeChild(tag);
        }
        xhr.send();
    }

    return (
        <div className="image-loader">
            {
                imgUrl ? (
                    <div className="image-loader-container">
                        <img src={`${IMAGE_DECHARGE_URL}/${subPath}/${imgUrl}`} alt="" style={imgWidth && imgHeight ? { width: imgWidth, height: imgHeight } : {}} />
                        {
                            downloadIcon == true && (
                                <span className="material-symbols-rounded shareCancelImg" onClick={() => downloadCarteImage()}>download</span>
                            )
                        }
                    </div>
                ) : (
                    <>
                        <label htmlFor="file">
                            <span style={{ color: 'tomato' }} className="material-symbols-rounded shareIcon">perm_media</span>
                            <span className="image-loader-text">{imageLabel}</span>
                            <input
                                style={{ display: "none" }}
                                type="file"
                                id="file"
                                accept=".png,.jpeg,.jpg"
                                onChange={(e) => setFileDecharge(e.target.files[0])}
                            />
                        </label>

                        {fileDecharge && (
                            <div className="image-loader-container">
                                <img src={URL.createObjectURL(fileDecharge)} alt="" />
                                <span className="material-symbols-rounded shareCancelImg" onClick={() => setFileDecharge(null)}>close</span>
                            </div>
                        )}
                    </>
                )
            }
        </div>
    )
}
